// store
import {
  GET_USERS,
  GET_EXT_USERS,
  CHANGE_USER,
  ADD_USER,
  SET_USERS,
  SET_EXT_USERS,
  DELETE_USER,
  GET_EXT_USERS_RELS,
  SET_EXT_USERS_RELS,
} from "../../store/actions/users";

// api
import {getUsersApi, getExtUsersApi, getRefItemExtUserRelsApi, changeUsersApi, addUsersApi, deleteUsersApi} from "@/api/users";

const state = {
  users: [],
  extUsers: []
};

const getters = {
  usersCount: state => state.users.length,
  users: state => state.users.slice().sort((a, b) => Number(a.group) > Number(b.group) ? 1 : -1),
  extUsersCount: state => state.extUsers.length,
  extUsers: state => state.extUsers.slice().sort((a, b) => Number(a.group) > Number(b.group) ? 1 : -1),
  //extUsersCount: state => state.extUsers.length,
  extUsersRels: state => state.extUsersRels
};

const actions = {
  [GET_USERS]: ({commit}) => {
    getUsersApi().then(resp => {
      commit(SET_USERS, resp.data);
    });
  },
  [GET_EXT_USERS]: ({commit}, params) => {
    getExtUsersApi(params).then(resp => {
      commit(SET_EXT_USERS, resp.data.items);
    });
  },
  [GET_EXT_USERS_RELS]: ({commit}, params) => {
    getRefItemExtUserRelsApi(params).then(resp => {
      commit(SET_EXT_USERS_RELS, resp.data);
    });
  },
  [CHANGE_USER]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      changeUsersApi(params)
        .then(resp => {
          commit(CHANGE_USER, {resp: resp.data, email: params.email});
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    }),
  [DELETE_USER]: ({ commit }, uid) =>
    new Promise((resolve, reject) => {
      deleteUsersApi({uid})
        .then(() => {
          commit(DELETE_USER, uid);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    }),
  [ADD_USER]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      addUsersApi(params)
        .then(resp => {
          commit(ADD_USER, {resp: resp.data, email: params.email});
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    }),
};

const mutations = {
  [DELETE_USER]: (state, uid) => {
    state.users = state.users.filter(item => item.uid !== uid);
  },
  [ADD_USER]: (state, {resp, email}) => {
    state.users.push({...resp, email});
  },
  [CHANGE_USER]: (state, {resp, email}) => {
    state.users = state.users.map(item => {
      if (Number(item.uid) === resp.uid) {
        return {...resp, email}
      }

      return item;
    })
  },
  [SET_USERS]: (state, payload) => {
    state.users = payload;
  },
  [SET_EXT_USERS]: (state, payload) => {
    state.extUsers = payload;
  },
  [SET_EXT_USERS_RELS]: (state, payload) => {
    state.extUsersRels = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
